import { render } from "./TopicCultureSelector.vue?vue&type=template&id=2c520620&scoped=true"
import script from "./TopicCultureSelector.vue?vue&type=script&lang=js"
export * from "./TopicCultureSelector.vue?vue&type=script&lang=js"

import "./TopicCultureSelector.vue?vue&type=style&index=0&id=2c520620&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c520620"]])

export default __exports__